function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .class1 {\r\n        fill: #f9f9f9;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .class1, .class2 {\r\n        stroke: #626a84;\r\n      }\r\n\r\n      .class2, .class4 {\r\n        fill: none;\r\n      }\r\n\r\n      .class2 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .class3 {\r\n        stroke: none;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Double_Tick",
  "data-name": "Double Tick",
  transform: "translate(-577 -511)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_651",
  "data-name": "Rectangle 651",
  className: "class1",
  transform: "translate(623 511) rotate(45)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "class3",
  width: 65.054,
  height: 65.054,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "class4",
  x: 1.5,
  y: 1.5,
  width: 62.054,
  height: 62.054,
  rx: 10.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1126",
  "data-name": "Group 1126",
  transform: "translate(-85 -72)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_624",
  "data-name": "Path 624",
  className: "class2",
  d: "M7,17,17,27,37,7",
  transform: "translate(691 614)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_625",
  "data-name": "Path 625",
  className: "class2",
  d: "M2,17,12,27M22,17,32,7",
  transform: "translate(686 614)"
})));

var SvgDoubleTick = function SvgDoubleTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-tick.0090b1b4.svg";
export { ForwardRef as ReactComponent };